// src/contexts/AdminContext.tsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { User } from "../types/admin";
import { AdminApi } from "../Api/AdminApi";
import { useMsal } from "@azure/msal-react";

interface AdminContextType {
  isAdmin: boolean;
  setIsAdmin: (value: boolean) => void;
  loading: boolean;
  currentUser?: User;
}

const AdminContext = createContext<AdminContextType | null>(null);

interface AdminProviderProps {
  children: React.ReactNode;
}

export const AdminProvider: React.FC<AdminProviderProps> = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [currentUser, setCurrentUser] = useState<User | undefined>(undefined);
  
    const { instance, accounts } = useMsal();
    const api = new AdminApi(accounts[0], instance);

  useEffect(() => {
    const fetchCurrentUser = async () => {

      try {
        const user = await api.getCurrentUser();
        setIsAdmin(user?.isAdmin ?? false);
        setCurrentUser(user);
      } catch (error) {
        console.error("Erreur lors de la récupération de l'utilisateur courant :", error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentUser();
  }, []);

  return (
    <AdminContext.Provider value={{ isAdmin, setIsAdmin, loading, currentUser }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = (): AdminContextType => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error("useAdmin doit être utilisé à l'intérieur d'un AdminProvider");
  }
  return context;
};
